<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ./src/assets/sass/m3_variables
@import ./src/assets/sass/m3_forms
</style>

<template>
    <div class="g_select g_placeholder" :class="['g_' + (data.id), {g_required: data.required, g_more: value === data.options[data.options.length - 1], g_nomargin: nomargin}]">
        <select
            v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)"
            :id="data.id"
            :name="data.id"
            :class="{g_error: data.error, g_filled: value !== ''}">
            <option
                v-for="(option, j) in formatOptionsDates(data.options)"
                :key="j"
                v-html="option" />
        </select>
        <label :for="data.id">
            <span v-html="data.label" />
        </label>
        <div class="fn_chevron_down" />
        <span v-html="data.error" class="g_error" />
    </div>
</template>

<script>
import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)

export default {
    name: 'select',
    props: {
        value: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            required: true
        },
        nomargin: {
            type: Boolean,
            default: false
        }
    },
    // data () {
    // },
    methods: {
        formatOptionsDates (data) {
            let opt = []
            const date = new Date()
            const year = date.getFullYear()
            const nextyear = year + 1
            data.forEach(element => {
                if (element === '2021') {
                    opt.push(year)
                } else if (element === '2022') {
                    opt.push(nextyear)
                } else {
                    opt.push(element)
                }
            })
            return opt
        }
    }
}
</script>
